/**
 * @namespace UsabilityClick
 * @aka PIANO.UsabilityClick
 *
 */
PIANO.UsabilityClick = function (window, document) {

  //Allgemeiner Event-Listener, der Daten empfängt und diese in
  //die PIANO Queue schreibt.
  document.addEventListener('piano:usabilityClick', function (event) {

    if (!PIANO.Utils.isEnabled()) {
      return;
    }

    console.debug('Tracking Piano UsabilityClick:', event.detail);

    //click_chapter2 soll immer die Sophora-ID sein, laut Anforderungen
    var clickData = {
      'click': event.detail.click,
      'click_chapter1': event.detail.click_chapter1,
      'click_chapter2': PIANO.Utils.getPageInformation('contentId'),
      'click_chapter3': event.detail.click_chapter3
    };

    PIANO.Queue.push({name: 'click.' + event.detail.type, data: clickData});
  });

  // Listen to all clicks on the document
  document.addEventListener('click', function (event) {

    if (!PIANO.Utils.isEnabled()) {
      return;
    }

    //Prüfen ob eines der Elemente in der Liste geklickt wurde
    for (const [key] of Object.entries(usabilityClickElements)) {
      if (event.target.closest(key)) {
        checkData(event.target.closest(key), key);
      }
    }

    //Keines der Elemente der Liste wurde geklickt
    return void 0;

  }, false);

  function checkData(element, key) {
    var element_data = Object.assign({}, usabilityClickElements[key]);
    var modal = element.closest('.modal');
    var modalHeadline = modal ? (modal.querySelector('.modal-title') ? modal.querySelector('.modal-title').innerText : '') : '';
    var zielUrl = element.href ? element.href : "";
    var form = element.closest('.form');
    var actionUrl = form ? (form.hasAttribute('action') ? form.getAttribute('action') : '') : '';
    var sharebuttonName = element.hasAttribute('data-share') ? element.getAttribute('data-share') : 'null';

    //Name des Share-Buttons anpassen
    if (element.classList.contains('btn-share-mail')) {
      sharebuttonName = 'Mail';
    } else {
      //Den ersten Buchstaben groß schreiben
      sharebuttonName = sharebuttonName.charAt(0).toUpperCase() + sharebuttonName.slice(1);
    }

    //Wenn es ein Block-Link ist:
    if (element.closest('.block-link')) {
      element_data.click = 'Navigation via Block-Link mit Inhalt "{INNER-TEXT}"';
      element_data.click_chapter1 = 'CTA';
    }

    //Wenn es ein Download-Link ist:
    if (zielUrl.match(/\.(doc|xls|pdf|zip|txt|jp[eg]*|png|rtf|mp4)/gi)) {
      element_data.type = 'download';
      element_data.click = 'Download-Link mit Inhalt "{INNER-TEXT}" wurde geklickt';
      element_data.click_chapter1 = 'Download';
    }

    //Platzhalter ersetzen:
    element_data.click = replaceVariable(element_data.click, {
      'ATTR-ARIA-LABEL': element.getAttribute('aria-label') + '',
      'INNER-TEXT': element.innerText,
      'SHAREBUTTON-NAME': sharebuttonName
    });

    element_data.click_chapter3 = replaceVariable(element_data.click_chapter3, {
      'ACTION-URL': actionUrl,
      'ZIEL-URL': zielUrl,
      'MODAL-HEADLINE': modalHeadline,
      'ATTR-ARIA-LABEL': element.getAttribute('aria-label') + '',
      'ATTR-TITLE': element.getAttribute('title') + ''
    });

    usabilityClickEvent(element_data);
  }

  function replaceVariable(string, replace) {
    for (const [key, value] of Object.entries(replace)) {
      var regex = new RegExp("{" + key + "}", "g");
      string = string.replaceAll(regex, value);
    }
    return string;
  }

  /**
   *
   * @param data
   *
   * data braucht folgende Felder:
   * type             Typ des Klicks (action, exit, navigation oder download)
   * click            Sprechende Bezeichnung des angeklickten Elements
   * click_chapter1   Element-Name (Menü, Breadcrumb, Share, Footer, Text-Link im Copytext)
   * click_chapter3   Infos (Ziel-URL soweit vorhanden, sonst andere nützliche Information)
   *
   * Beispiel:
   * {
   *  'type': 'navigation',
   *  'click': 'Navigation via Text-Link mit Inhalt "Blabla"',
   *  'click_chapter1': 'Text-Link im Copytext',
   *  'click_chapter3': 'https://www.swr.de/test-102.html'
   * }
   */
  var usabilityClickEvent = function usabilityClickEvent(data) {
    PIANO.Utils.trigger('usabilityClick', data);
  }

  /**
   * --------------------------------------------------------------------------
   * Public Pageview Api
   * --------------------------------------------------------------------------
   */
  return {
    usabilityClickEvent: usabilityClickEvent
  };

}(window, document);
